import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=02ab4b21&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=02ab4b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab4b21",
  null
  
)

export default component.exports